import _enTranslations from './en.json';

const translation = {
  ..._enTranslations,
};

export default translation;
